
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 80 80"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#7CD1A3","fill-opacity":".5","fill-rule":"evenodd","d":"M25.73 13a8 8 0 00-8 8v.75H75V21a8 8 0 00-8-8H25.73zM75 28.11H17.73v15.07a8 8 0 008 8H67a8 8 0 008-8V28.11z","clip-rule":"evenodd"}}),_c('path',{attrs:{"fill":"#7CD1A4","d":"M5 36.11a8 8 0 018-8h41.27a8 8 0 018 8V58.3a8 8 0 01-8 8H13a8 8 0 01-8-8V36.1z"}}),_c('rect',{attrs:{"width":"12.73","height":"4.77","x":"10.57","y":"53.57","fill":"#fff","rx":"2.39"}})])
          )
        }
      }
    